// NY recreational cannabis combined excise + local tax. NY taxes the retail
// price BEFORE any discount, so BOGO/promo savings do not reduce the tax base.
export const TAX_RATE = 0.13;

// Tax owed on a single unit of a given variant. Always computed on the
// regular (priceRec) price — never on the sale price — to match NY rules.
export function unitTax(variant) {
    const base = Number(variant?.priceRec) || 0;
    return base * TAX_RATE;
}

// After-tax price displayed under the headline price.
// `unitPrice` is whatever the customer actually pays (sale price if on sale,
// else regular price). Tax is added on top, computed from the pre-discount
// base via `unitTax(variant)`.
export function withTax(unitPrice, variant) {
    return (Number(unitPrice) || 0) + unitTax(variant);
}

// Convenience for templates: "$xx.xx"
export function fmt(n) {
    if (n == null || isNaN(n)) return "—";
    return `$${Number(n).toFixed(2)}`;
}

// Whole-dollar formatter used for after-tax callouts on product cards —
// shoppers want a clean "≈ $45" rather than "$44.85" precision.
export function fmtRound(n) {
    if (n == null || isNaN(n)) return "—";
    return `$${Math.round(Number(n)).toLocaleString()}`;
}
